import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { TeachingLibrary } from './components/TeachingLibrary';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import type { MetaPixel } from './types/pixel';
const META_PIXEL_ID = '1049314170929647';
interface AppProps {
  showPurchaseNotifications?: boolean;
}
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
        } as ((...args: unknown[]) => void) & MetaPixel;
        pixel.queue = [];
        pixel.push = (...args: unknown[]) => pixel.queue.push(args);
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        if (!window._fbq) window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-base text-ink selection:bg-brand/20 selection:text-brand-dark" data-id="element-0" data-mp="34x2njg6zd4f">
      <main data-id="element-1" data-mp="3ucjdbw1bwfus">
        <Hero data-id="element-2" data-mp="3uf5ixq4nslad" />
        <TestimonialsStrip data-id="element-3" data-mp="d4nuteha5g1c" />
        <PainPoints data-id="element-4" data-mp="d4xq9hl3gfef" />
        <SolutionReveal data-id="element-5" data-mp="d45sc040y5kz" />
        <VolumesSection data-id="element-6" data-mp="d2l7513lnyzs" />
        <TeachingLibrary data-id="element-7" data-mp="85uk1ttdo34v" />
        <BonusSection data-id="element-8" data-mp="86meh1b8nutk" />
        <PricingSection data-id="element-9" data-mp="8649ngaig8a1" />
        <ExtendedTestimonials data-id="element-10" data-mp="83qihiiybg7r" />
        <Guarantee data-id="element-11" data-mp="3gkv1ltuzrtec" />
        <FAQ data-id="element-12" data-mp="3gmfsn9i3ku7g" />
        <FinalCTA data-id="element-13" data-mp="3glwb3twd07ty" />
      </main>
      <Footer data-id="element-14" data-mp="3gj1vqgs7dd7e" />
      {showPurchaseNotifications && <PurchaseNotifications data-id="element-15" data-mp="3bncodr9xys0j" />}
    </div>;
}